module.exports = __webpack_public_path__ + "img/40_38.cfef6b3d.png";